var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
/**
 * CalendarViewSwitcher Component
 *
 * Dedicated control that lets users switch between the Monthly and Yearly
 * calendar experiences. This mirrors the legacy GRM calendar mode toggle, where
 * Monthly and Yearly are two views of the same resource's calendar.
 *
 * The component is presentational: the parent owns the navigation behaviour and
 * passes a handler for the inactive view. The currently active view is rendered
 * as a non-actionable segment.
 */
import React, { memo, useCallback } from 'react';
import { styles } from './CalendarViewSwitcher.styles';
export const CalendarViewSwitcher = memo(({ activeView, showMonthly = true, onMonthlyClick, onYearlyClick, disabled = false, }) => {
    const handleMonthly = useCallback(() => {
        if (!disabled && activeView !== 'monthly') {
            onMonthlyClick === null || onMonthlyClick === void 0 ? void 0 : onMonthlyClick();
        }
    }, [disabled, activeView, onMonthlyClick]);
    const handleYearly = useCallback(() => {
        if (!disabled && activeView !== 'yearly') {
            onYearlyClick === null || onYearlyClick === void 0 ? void 0 : onYearlyClick();
        }
    }, [disabled, activeView, onYearlyClick]);
    const segmentStyle = (view) => (Object.assign(Object.assign(Object.assign({}, styles.segment), (activeView === view ? styles.segmentActive : styles.segmentInactive)), (disabled ? styles.segmentDisabled : {})));
    return (React.createElement("div", { style: styles.container, role: "group", "aria-label": "Calendar view switcher" },
        showMonthly && (React.createElement("button", { type: "button", style: segmentStyle('monthly'), onClick: handleMonthly, disabled: disabled, "aria-pressed": activeView === 'monthly' }, "Monthly")),
        React.createElement("button", { type: "button", style: segmentStyle('yearly'), onClick: handleYearly, disabled: disabled, "aria-pressed": activeView === 'yearly' }, "Yearly")));
});
CalendarViewSwitcher.displayName = 'CalendarViewSwitcher';
export default CalendarViewSwitcher;
//# sourceMappingURL=CalendarViewSwitcher.js.map